// extracted by mini-css-extract-plugin
export default {"addressSection":"KQ-z","disabled":"LQ-z","sectionButtons":"MQ-z","logo":"NQ-z"};